import { Observable, UnaryFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export function rxJsonClone<T>(): UnaryFunction<Observable<T>, Observable<T>> {
  return (source: Observable<T>) => {
    return source.pipe(map((value) => JSON.parse(JSON.stringify(value)) as T));
  };
}
